// when edit this file, please use commonJS format since this used on express app too (Hypernova)

const renderReactHypernova = require('hypernova-react').renderReact
const root = require('baobab-react/higher-order').root
const storage = require('./storage')

const renderReact = (name, component) => renderReactHypernova(name, root(storage, component))

module.exports = renderReact
